import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Block, Save, Search, Add } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import { IconButton } from "@material-ui/core";
import PopupForm from "app/common/Component/Popup/PopupForm";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import {
  LIST_GENDER,
  PATIENT_TYPE_SERVICE,
  phoneRegExp,
  RELATIONSHIP_TYPES
} from "app/common/LocalConst";
import { getListCodeSourceCTV, getListCodeSourceDiChung, hideMiddleDigits, transformDate, withNameSpace } from "app/common/LocalFunction";
import { ListFamilyRelationship } from "app/LocalConstants";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { pagingPatientGroup } from "app/services/PatientGroupType";
import { pagingPatientRank } from "app/services/PatientRank";
import { pagingPatientType } from "app/services/PatientType";
import { pagingPatientTypeService } from "app/services/PatientTypeServiceService";
import { pagingProfession } from "app/services/ProfessionService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useState } from "react";
import useDynamicValidation from "app/common/hooks/useDynamicValidation";
import { useTranslation } from "react-i18next";
import PatientAddress from "../Form/PatientAddress";
import FormikFocusError from "app/common/form/FormikFocusError";
import BirthDateAge from "app/common/Component/Patient/BirthDateAge";
import { pagingCustomerSourceGroup } from "app/services/CustomerSourceGroupService";
import { pagingCountry } from "app/services/CountryService";
import SendIcon from "@material-ui/icons/Send";
import IconPen from "app/common/Icon/IconPen";
import IconDelete from "app/common/Icon/IconDelete";
import { pagingPatient } from "app/services/PatientService";
import * as Yup from "yup";
import { pagingStaff } from "app/services/StaffService";
import { POSITION_CONSULTANT, POSITION_TELESALE } from "app/appConfig";
import { pagingReferralPartner } from "../../../services/ReferralPartnerService";
import ReferralPartnerPopup from "./ReferralPartner/ReferralPartnerPopup";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import { CHECKIN_IN_FORM_PATIENT } from "../../../appConfig";
import { isAdmin } from "../../../common/LocalFunction";
import { pagingDepartment } from "app/services/DepartmentService";
import ListRelatedPerson from "app/PatientManagement/PatientList/Popup/ListRelatedPerson";

const CreatePatientPopup = ({
  nameSpace = "",
  handleAfterSubmit,
  isHideCheckInButton = false,
  isCloseAfterSubmit = false,
}) => {
  const {
    initialPatient,
    openFormCreateOrEdit,
    handleCloseCreateOrEditPopup,
    saveOrUpdatePatient,
    handleOpenFormCheckIn,
    handleChangeFormSearchLead,
    handleChangeFormSearchDuplicate,
  } = useStore().patientManagementStore.patientListStore;
  const isAdminRole = isAdmin();
  const listCodeSourceCTV = getListCodeSourceCTV();
  const listCodeSourceDiChung = getListCodeSourceDiChung();

  const { requiredFields, isRequired } = useDynamicValidation("PATIENT_REQUIRED_FIELDS");

  const renderTitle = () => {
    let title = " Hồ sơ";
    if (initialPatient?.id) {
      title += ` ${initialPatient?.displayName}`;
      if (initialPatient?.code) {
        title += ` - ${initialPatient?.code}`;
      }
      return (
        <div className="flex align-center gap-2">
          <>
            <IconPen color="white" />
          </>
          {title}
        </div>
      );
    } else {
      return "Thêm mới hồ sơ khách hàng";
    }
  };

  const validationSchema = React.useMemo(() => {

    const phoneNumberSubSchema = Yup.string()
      .nullable()
      .test(
        "is-digits-only",
        "Phải là chuỗi số",
        (value) => !value || /^[0-9]+$/.test(value)
      )
      .test(
        "length-between-10-20",
        "Độ dài phải từ 10 đến 20 chữ số",
        (value) => !value || (value.length >= 10 && value.length <= 20)
      );

    return Yup.object().shape({
      displayName: Yup.string()
        .nullable()
        .test(
          "required-displayName",
          "Chưa nhập tên khách hàng!",
          (val) => {
            if (isRequired("displayName", true)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      oldCode: Yup.string()
        .nullable()
        .test(
          "required-oldCode",
          "Chưa nhập Mã HT cũ!",
          (val) => {
            if (isRequired("oldCode", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      age: Yup.string()
        .nullable()
        .test("max", "Tuổi nhỏ hơn 150", (data) => {
          if (+data > 150) return false;
          return true;
        }),
      phoneNumber: Yup.string()
        .nullable()
        .test(
          "required-phoneNumber",
          "Bạn chưa nhập số điện thoại!",
          (val) => {
            if (isRequired("phoneNumber", true)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        )
        .test("is-digits-only", "Phải là chuỗi số", (val) => {
          if (!val) return true;
          return /^[0-9]+$/.test(val);
        })
        .test(
          "length-between-10-20",
          "Độ dài phải từ 10 đến 20 chữ số",
          (val) => {
            if (!val) return true;
            return val?.length >= 10 && val?.length <= 20;
          }
        ),
      subPhoneNumber: phoneNumberSubSchema
        .test(
          "required-subPhoneNumber",
          "Chưa nhập SĐT 2!",
          (val) => {
            if (isRequired("subPhoneNumber", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      phoneNumber3: phoneNumberSubSchema
        .test(
          "required-phoneNumber3",
          "Chưa nhập SĐT 3!",
          (val) => {
            if (isRequired("phoneNumber3", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      phoneNumber4: phoneNumberSubSchema
        .test(
          "required-phoneNumber4",
          "Chưa nhập SĐT 4!",
          (val) => {
            if (isRequired("phoneNumber4", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      idNumber: Yup.string()
        .nullable()
        .test(
          "required-idNumber",
          "Chưa nhập CMND/CCCD!",
          (val) => {
            if (isRequired("idNumber", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        )
        .test("invaild-idNumber", "CMND/CCCD không đúng định dạng", (value) => {
          if (value) {
            if (
              value?.length === 8 ||
              value?.length === 9 ||
              value?.length === 12
            ) {
              return true;
            }
            return false;
          }
          return true;
        })
        .matches(/^[0-9]*$/, "CMND/CCCD chỉ được nhập chữ số"),
      idNumberIssueDate: Yup.date()
        .transform(transformDate)
        .nullable()
        .test(
          "required-idNumberIssueDate",
          "Chưa nhập Ngày cấp CMND/CCCD!",
          (val) => {
            if (isRequired("idNumberIssueDate", false)) {
              return Boolean(val);
            }
            return true;
          }
        ),
      idNumberIssueBy: Yup.string()
        .nullable()
        .test(
          "required-idNumberIssueBy",
          "Chưa nhập Nơi cấp CMND/CCCD!",
          (val) => {
            if (isRequired("idNumberIssueBy", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      birthDate: Yup.date()
        .transform(transformDate)
        .nullable()
        .test(
          "required-birthDate",
          "Chưa nhập ngày sinh khách hàng!",
          (val) => {
            if (isRequired("birthDate", false)) {
              return Boolean(val);
            }
            return true;
          }
        ),
      gender: Yup.string()
        .nullable()
        .test(
          "required-gender",
          "Chưa chọn giới tính!",
          (val) => {
            if (isRequired("gender", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      currentProvince: Yup.object()
        .nullable()
        .test(
          "required-currentProvince",
          "Chưa chọn Tỉnh/Thành phố hiện tại!",
          (val) => {
            if (isRequired("currentProvince", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentDistrict: Yup.object()
        .nullable()
        .test(
          "required-currentDistrict",
          "Chưa chọn Quận/Huyện hiện tại!",
          (val) => {
            if (isRequired("currentDistrict", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentWard: Yup.object()
        .nullable()
        .test(
          "required-currentWard",
          "Chưa chọn Phường/Xã hiện tại!",
          (val) => {
            if (isRequired("currentWard", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentDetailResidence: Yup.string()
        .nullable()
        .test(
          "required-currentDetailResidence",
          "Chưa nhập Địa chỉ chi tiết!",
          (val) => {
            if (isRequired("currentDetailResidence", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      firstPatientSource: Yup.object()
        .nullable()
        .test(
          "required-firstPatientSource",
          "Chưa chọn Nguồn đầu tiên!",
          (val) => {
            if (isRequired("firstPatientSource", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      firstPatientSourceDetail: Yup.object()
        .nullable()
        .test(
          "required-firstPatientSourceDetail",
          "Chưa chọn Nguồn đầu tiên (Chi tiết)!",
          (val) => {
            if (isRequired("firstPatientSourceDetail", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentPatientSource: Yup.object()
        .nullable()
        .test(
          "required-currentPatientSource",
          "Chưa chọn Nguồn hiện tại!",
          (val) => {
            if (isRequired("currentPatientSource", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentPatientSourceDetail: Yup.object()
        .nullable()
        .test(
          "required-currentPatientSourceDetail",
          "Chưa chọn Nguồn hiện tại (Chi tiết)!",
          (val) => {
            if (isRequired("currentPatientSourceDetail", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentPatientGroup: Yup.object()
        .nullable()
        .test(
          "required-currentPatientGroup",
          "Chưa chọn Nhóm khách hàng!",
          (val) => {
            if (isRequired("currentPatientGroup", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentPatientType: Yup.object()
        .nullable()
        .test(
          "required-currentPatientType",
          "Chưa chọn Loại khách hàng!",
          (val) => {
            if (isRequired("currentPatientType", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentPatientRank: Yup.object()
        .nullable()
        .test(
          "required-currentPatientRank",
          "Chưa chọn Hạng khách hàng!",
          (val) => {
            if (isRequired("currentPatientRank", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentPatientTypeService: Yup.object()
        .nullable()
        .test(
          "required-currentPatientTypeService",
          "Chưa chọn Đối tượng khách hàng!",
          (val) => {
            if (isRequired("currentPatientTypeService", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentTelesale: Yup.object()
        .nullable()
        .test(
          "required-currentTelesale",
          "Chưa chọn Telesale hiện thời 1!",
          (val) => {
            if (isRequired("currentTelesale", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentTelesale2: Yup.object()
        .nullable()
        .test(
          "required-currentTelesale2",
          "Chưa chọn Telesale hiện thời 2!",
          (val) => {
            if (isRequired("currentTelesale2", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentConsultant: Yup.object()
        .nullable()
        .test(
          "required-currentConsultant",
          "Chưa chọn Người Checkin!",
          (val) => {
            if (isRequired("currentConsultant", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      currentCustomerCareAgent: Yup.object()
        .nullable()
        .test(
          "required-currentCustomerCareAgent",
          "Chưa chọn CSKH hiện thời!",
          (val) => {
            if (isRequired("currentCustomerCareAgent", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      email: Yup.string()
        .nullable()
        .test(
          "required-email",
          "Chưa nhập Email!",
          (val) => {
            if (isRequired("email", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      profession: Yup.object()
        .nullable()
        .test(
          "required-profession",
          "Chưa chọn Nghề nghiệp!",
          (val) => {
            if (isRequired("profession", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      ethnics: Yup.object()
        .nullable()
        .test(
          "required-ethnics",
          "Chưa chọn Dân tộc!",
          (val) => {
            if (isRequired("ethnics", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      nationality: Yup.object()
        .nullable()
        .test(
          "required-nationality",
          "Chưa chọn Quốc tịch!",
          (val) => {
            if (isRequired("nationality", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        ),
      note: Yup.string()
        .nullable()
        .test(
          "required-note",
          "Chưa nhập Ghi chú!",
          (val) => {
            if (isRequired("note", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      idFacebook: Yup.string()
        .nullable()
        .test(
          "required-idFacebook",
          "Chưa nhập Id Facebook!",
          (val) => {
            if (isRequired("idFacebook", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      idZalo: Yup.string()
        .nullable()
        .test(
          "required-idZalo",
          "Chưa nhập Id Zalo!",
          (val) => {
            if (isRequired("idZalo", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      idTiktok: Yup.string()
        .nullable()
        .test(
          "required-idTiktok",
          "Chưa nhập Id Tiktok!",
          (val) => {
            if (isRequired("idTiktok", false)) {
              return !(!Boolean(val) || val?.trim() === "");
            }
            return true;
          }
        ),
      referralPartner: Yup.object()
        .nullable()
        .test(
          "required-referralPartner",
          "Bắt buộc phải chọn cộng tác viên!",
          (val) => {
            if (isRequired("referralPartner", false)) {
              return Boolean(val && val.id);
            }
            return true;
          }
        )
        .when("currentPatientSource", {
          is: (source) => source && listCodeSourceCTV.includes(source.code),
          then: Yup.object().required("Bắt buộc phải chọn cộng tác viên!").nullable(),
          otherwise: Yup.object().nullable(),
        }),
      relatedPersons: Yup.array()
        .nullable()
        .when("currentPatientSource", {
          is: (source) => source && listCodeSourceDiChung.includes(source.code),
          then: Yup.array().test(
            "has-related-person",
            "Bắt buộc có ít nhất 1 mối quan hệ",
            (value) => {
              if (!value || !Array.isArray(value)) return false;
              const count = value.filter(item => !item.voided).length;
              return count > 0;
            }
          ).nullable(),
          otherwise: Yup.array().nullable(),
        }),
    });
  }, [requiredFields, isRequired, listCodeSourceCTV, listCodeSourceDiChung]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <PopupForm
      open={openFormCreateOrEdit}
      size="xxl"
      height="75vh"
      handleClose={handleCloseCreateOrEditPopup}
      title={renderTitle()}
      formik={{
        initialValues: {
          ...initialPatient,
        },
        onSubmit: async (values, { setSubmitting }) => {
          const newValues = {
            ...values,
            referralPartnerId: values?.referralPartner?.id,
            referralPartnerName: values?.referralPartner?.name,
            referralPartnerCode: values?.referralPartner?.code,
          };
          let data = await saveOrUpdatePatient(newValues, { setSubmitting });
          if (handleAfterSubmit) {
            handleAfterSubmit(data);
          }
          if (isCloseAfterSubmit) {
            handleCloseCreateOrEditPopup();
          }
        },
        validationSchema: validationSchema,
        enableReinitialize: true,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            {/* {!isHideCheckInButton &&
              initialPatient?.id &&
              CHECKIN_IN_FORM_PATIENT && (
                <CommonButton
                  className="btn-send"
                  onClick={() => {
                    handleOpenFormCheckIn(initialPatient);
                  }}
                >
                  {!isMobile && <SendIcon className="mr-2 " />}
                  Check in
                </CommonButton>
            )} */}
            <CommonButton
              disabled={isSubmitting}
              type="submit"
              className="btn-primary"
            >
              {!isMobile && <Save className="mr-2 " />}
              Lưu thông tin
            </CommonButton>

            <CommonButton
              className="btn-gray"
              onClick={handleCloseCreateOrEditPopup}
            >
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              nameSpace={nameSpace}
              handleChangeFormSearchLead={handleChangeFormSearchLead}
              handleChangeFormSearchDuplicate={handleChangeFormSearchDuplicate}
              initialPatient={initialPatient}
              isMobile={isMobile}
              isAdminRole={isAdminRole}
              listCodeSourceCTV={listCodeSourceCTV}
              requiredFields={requiredFields}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({
    initialPatient,
    nameSpace,
    handleChangeFormSearchLead,
    handleChangeFormSearchDuplicate,
    isMobile,
    isAdminRole,
    listCodeSourceCTV,
    requiredFields = {},
  }) => {
    const { setFieldValue, values } = useFormikContext();
    const { t } = useTranslation();
    const handleCheckDup = async (obj) => {
      const {
        id = values?.id,
        phoneNumber = obj?.phoneNumber || values?.phoneNumber,
        idNumber = obj?.idNumber || values?.idNumber,
      } = obj;
      if (!id) {
        if (
          phoneNumber?.length >= 10 ||
          idNumber?.length === 12 ||
          idNumber?.length === 9 ||
          idNumber?.length === 8
        ) {
          await handleChangeFormSearchDuplicate({
            patient: { phoneNumber, idNumber },
          });
        }
      }
    };
    const [openReferralPartner, setOpenReferralPartner] = useState(false);
    return (
      <>
        <FormikFocusError />
        <section className=" form-patient">
          <div className="item-form-patient" style={{ borderRadius: "5px" }}>
            <p className="item-form-header flex align-center">
              1 {t("patient.administrativeInformation")}
            </p>

            <Grid container spacing={1} className="w-100 m-0">
              {values?.code && (
                <Grid item xs={12} sm={6} md={2}>
                  <GlobitsTextField
                    name={withNameSpace("code", nameSpace)}
                    label="Mã khách hàng"
                    required={requiredFields?.["code"] === true}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  name={withNameSpace("oldCode", nameSpace)}
                  label="Mã HT cũ"
                  autoUpercase
                  required={requiredFields?.["oldCode"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  name={withNameSpace("displayName", nameSpace)}
                  label="Họ tên khách hàng"
                  autoUpercase
                  required={requiredFields?.["displayName"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("Số điện thoại")}
                  name={withNameSpace("phoneNumber", nameSpace)}
                  onChange={async (event) => {
                    setFieldValue(
                      withNameSpace("phoneNumber", nameSpace),
                      event?.target?.value
                    );
                    handleCheckDup({ phoneNumber: event?.target?.value });
                  }}
                  required={requiredFields?.["phoneNumber"] === true}
                  disabled={initialPatient?.id && !isAdminRole}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("SĐT 2")}
                  name={withNameSpace("subPhoneNumber", nameSpace)}
                  required={requiredFields?.["subPhoneNumber"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("SĐT 3")}
                  name={withNameSpace("phoneNumber3", nameSpace)}
                  required={requiredFields?.["phoneNumber3"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("SĐT 4")}
                  name={withNameSpace("phoneNumber4", nameSpace)}
                  required={requiredFields?.["phoneNumber4"] === true}
                />
              </Grid>
              <BirthDateAge
                setFieldValue={setFieldValue}
                nameSpaceDate={""}
                nameSpaceAge={""}
                required={requiredFields?.["birthDate"] === true}
              />
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsSelectInput
                  label={t("gender")}
                  name={withNameSpace("gender", nameSpace)}
                  options={LIST_GENDER}
                  autoUpercase
                  required={requiredFields?.["gender"] === true}
                />
              </Grid>
              <PatientAddress nameSpace={nameSpace} requiredFields={requiredFields} />
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("patient.email")}
                  name={withNameSpace("email", nameSpace)}
                  required={requiredFields?.["email"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("profession", nameSpace)}
                  label={t("patient.profession")}
                  api={pagingProfession}
                  autoUpercase
                  getOptionSelected={(row) => {
                    return `${row?.code} - ${row?.name}`.toUpperCase();
                  }}
                  required={requiredFields?.["profession"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  type="text"
                  label={t("patient.idNumber")}
                  name={withNameSpace("idNumber", nameSpace)}
                  required={requiredFields?.["idNumber"] === true}
                  onChange={(e) => {
                    let value = e?.target?.value;
                    setFieldValue(withNameSpace("idNumber", nameSpace), value);
                    if (value?.length === 9 || value?.length === 12) {
                      handleCheckDup({ idNumber: value });
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsDateTimePicker
                  label={t("Ngày cấp")}
                  name={withNameSpace("idNumberIssueDate", nameSpace)}
                  maxDateMessage="Ngày cấp phải trước ngày hiện tại"
                  maxDate={new Date()}
                  required={requiredFields?.["idNumberIssueDate"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("Nơi cấp")}
                  name={withNameSpace("idNumberIssueBy", nameSpace)}
                  required={requiredFields?.["idNumberIssueBy"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  api={pagingCountry}
                  label={t("patient.nationality")}
                  name={withNameSpace("nationality", nameSpace)}
                  autoUpercase
                  required={requiredFields?.["nationality"] === true}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4} lg={2}>
                <GlobitsTextField
                  label={t("patient.relativeName")}
                  name={withNameSpace("relativeName", nameSpace)}
                  autoUpercase
                  tabIndex={-1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <GlobitsSelectInput
                  options={ListFamilyRelationship}
                  name={withNameSpace("relationship", nameSpace)}
                  label={t("patient.relationship")}
                  tabIndex={-1}
                  autoUpercase
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <GlobitsNumberInput
                  type="text"
                  label={t("patient.relativePhoneNumber")}
                  name={withNameSpace("relativePhoneNumber", nameSpace)}
                  tabIndex={-1}
                />
              </Grid> */}

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("Ghi chú")}
                  name={withNameSpace("note", nameSpace)}
                  required={requiredFields?.["note"] === true}
                />
              </Grid>
            </Grid>
          </div>
          <div
            className="item-form-patient"
            style={{
              borderEndStartRadius: "5px",
              borderEndEndRadius: "5px",
            }}
          >
            <p className="item-form-header flex align-center">
              2 {t("Thông tin khác")}
            </p>
            <Grid container spacing={1} className="w-100 m-0">
              <Grid item xs={12} sm={6} md={2} className="flex align-center">
                <GlobitsCheckBox
                  label={t("Là cộng tác viên")}
                  name={withNameSpace("isCollaborator", nameSpace)}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  api={pagingCustomerSource}
                  name={withNameSpace("firstPatientSource", nameSpace)}
                  label="Nguồn đầu tiên"
                  searchObject={{
                    level: 2,
                  }}
                  disabled={!isAdminRole}
                  required={requiredFields?.["firstPatientSource"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("firstPatientSourceDetail", nameSpace)}
                  label={t("Nguồn đầu tiên (Chi tiết)")}
                  disabled={!isAdminRole}
                  required={requiredFields?.["firstPatientSourceDetail"] === true}
                  api={
                    getIn(
                      values,
                      withNameSpace("firstPatientSource", nameSpace)
                    )?.id
                      ? pagingCustomerSource
                      : undefined
                  }
                  searchObject={
                    getIn(
                      values,
                      withNameSpace("firstPatientSource", nameSpace)
                    )?.id
                      ? {
                        parentId: getIn(
                          values,
                          withNameSpace("firstPatientSource", nameSpace)
                        )?.id,
                      }
                      : null
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  api={pagingCustomerSource}
                  name={withNameSpace("currentPatientSource", nameSpace)}
                  label="Nguồn hiện tại"
                  required={requiredFields?.["currentPatientSource"] === true}
                  searchObject={{
                    level: 2,
                  }}
                  onChange={(e, value) => {
                    setFieldValue(
                      withNameSpace("currentPatientSource", nameSpace),
                      value
                    );
                    if (
                      !getIn(values, withNameSpace("firstPatientSource", nameSpace)) &&
                      value
                    ) {
                      setFieldValue(
                        withNameSpace("firstPatientSource", nameSpace),
                        value
                      );
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  api={
                    getIn(
                      values,
                      withNameSpace("currentPatientSource", nameSpace)
                    )?.id
                      ? pagingCustomerSource
                      : undefined
                  }
                  name={withNameSpace("currentPatientSourceDetail", nameSpace)}
                  label={t("Nguồn hiện tại (Chi tiết)")}
                  required={requiredFields?.["currentPatientSourceDetail"] === true}
                  searchObject={
                    getIn(
                      values,
                      withNameSpace("currentPatientSource", nameSpace)
                    )?.id
                      ? {
                        parentId: getIn(
                          values,
                          withNameSpace("currentPatientSource", nameSpace)
                        )?.id,
                      }
                      : null
                  }
                // onChange={(e, value) => {
                //   setFieldValue(
                //     withNameSpace("currentPatientSourceDetail", nameSpace),
                //     value
                //   );
                //   if (
                //     !getIn(
                //       values,
                //       withNameSpace("firstPatientSourceDetail", nameSpace)
                //     ) &&
                //     value
                //   ) {
                //     setFieldValue(
                //       withNameSpace("firstPatientSourceDetail", nameSpace),
                //       value
                //     );
                //   }
                // }}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                api={pagingDepartment}
                name={withNameSpace("currentDepartmentName", nameSpace)}
                label={t("Cơ sở hiện thời kh")}
                getOptionLabel={(option) => option?.name || option || ""} 
                onChange={(e, value) => {
                  setFieldValue(
                    withNameSpace("currentDepartmentName", nameSpace),
                    value?.name || ""
                  );
                }}
              />
              </Grid> */}
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  api={pagingPatientGroup}
                  name={withNameSpace("currentPatientGroup", nameSpace)}
                  label={t("Nhóm khách hàng")}
                  required={requiredFields?.["currentPatientGroup"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("currentPatientType", nameSpace)}
                  label={t("Loại khách hàng")}
                  api={pagingPatientType}
                  required={requiredFields?.["currentPatientType"] === true}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("currentPatientRank", nameSpace)}
                  label={t("Hạng khách hàng")}
                  api={pagingPatientRank}
                  required={requiredFields?.["currentPatientRank"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("currentPatientTypeService", nameSpace)}
                  label={t("Đối tượng khách hàng")}
                  api={pagingPatientTypeService}
                  searchObject={{ type: PATIENT_TYPE_SERVICE[0].value }}
                  required={requiredFields?.["currentPatientTypeService"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("currentTelesale", nameSpace)}
                  label={t("Telesale hiện thời 1")}
                  api={pagingStaff}
                  getOptionLabel={(option) => option?.staffName || ""}
                  searchObject={{
                    positionCode: POSITION_TELESALE,
                    isActive: true,
                  }}
                  required={requiredFields?.["currentTelesale"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("currentTelesale2", nameSpace)}
                  label={t("Telesale hiện thời 2")}
                  api={pagingStaff}
                  getOptionLabel={(option) => option?.staffName || ""}
                  searchObject={{
                    positionCode: POSITION_TELESALE,
                    isActive: true,
                  }}
                  required={requiredFields?.["currentTelesale2"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("currentConsultant", nameSpace)}
                  label={t("Người Checkin")}
                  api={pagingStaff}
                  getOptionLabel={(option) => option?.staffName || ""}
                  searchObject={{
                    positionCode: POSITION_CONSULTANT,
                    isActive: true,
                  }}
                  required={requiredFields?.["currentConsultant"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("currentCustomerCareAgent", nameSpace)}
                  searchObject={{
                    positionCode: POSITION_CONSULTANT,
                    isActive: true,
                  }}
                  label={t("CSKH hiện thời")}
                  api={pagingStaff}
                  getOptionLabel={(option) => option?.staffName || ""}
                  required={requiredFields?.["currentCustomerCareAgent"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("Id facebook")}
                  name={withNameSpace("idFacebook", nameSpace)}
                  required={requiredFields?.["idFacebook"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("Id zalo")}
                  name={withNameSpace("idZalo", nameSpace)}
                  required={requiredFields?.["idZalo"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsTextField
                  label={t("Id tiktok")}
                  name={withNameSpace("idTiktok", nameSpace)}
                  required={requiredFields?.["idTiktok"] === true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={9}>
                    <GlobitsPagingAutocomplete
                      name={withNameSpace("referralPartner", nameSpace)}
                      label={t("CTV")}
                      api={pagingReferralPartner}
                      required={
                        (requiredFields?.["referralPartner"] === true) ||
                        (values?.currentPatientSource &&
                        listCodeSourceCTV.includes(values.currentPatientSource.code))
                      }
                      getOptionLabel={(option) => {
                        let label = option?.name;
                        if (option?.code) {
                          label += ` - ${option.code}`;
                        }
                        if (option?.phoneNumber) {
                          label += ` - ${hideMiddleDigits(option.phoneNumber)}`;
                        }
                        return label || "";
                      }}
                    />
                  </Grid>
                  <Grid item xs={3} className={"flex align-end"}>
                    <span>
                      <Tooltip title={"Xem chi tiết cộng tác viên"}>
                        <Button
                          startIcon={<TouchAppIcon />}
                          className="btn btn-primary d-inline-flex"
                          onClick={() => setOpenReferralPartner(true)}
                        ></Button>
                      </Tooltip>
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              {openReferralPartner && (
                <ReferralPartnerPopup
                  open={openReferralPartner}
                  handleClose={() => setOpenReferralPartner(false)}
                />
              )}
            </Grid>
          </div>

          <div
            className="item-form-patient mt-10"
            style={{
              borderEndStartRadius: "5px",
              borderEndEndRadius: "5px",
            }}
          >
            <p className="item-form-header flex align-center">
              3 {t("Danh sách mối quan hệ")}
            </p>
            <ListRelatedPerson isMobile={isMobile} />
          </div>
        </section>
      </>
    );
  }
);

export default memo(observer(CreatePatientPopup));
